import React from "react";
import { Building2, Plus, X } from "lucide-react";
import { DialogDescription, DialogTitle } from "@/components/ui/dialog";

interface AddBrandModalHeaderProps {
  onClose: () => void;
}

export const AddBrandModalHeader: React.FC<AddBrandModalHeaderProps> = ({ onClose }) => {
  return (
    <div className="p-6 pb-5 flex items-start justify-between border-b border-slate-100 relative">
      <div className="flex items-start gap-4 pr-10">
        <div className="w-12 h-12 rounded-2xl bg-[#A655F8]/10 flex items-center justify-center relative text-[#A655F8] shrink-0">
          <Building2 className="w-6 h-6 text-[#A655F8]" />
          <div className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full bg-[#A655F8] text-white flex items-center justify-center border-2 border-white">
            <Plus className="w-3 h-3 stroke-[3]" />
          </div>
        </div>

        <div>
          <DialogTitle className="text-xl font-bold text-slate-900 tracking-tight">
            Add New Brand
          </DialogTitle>
          <DialogDescription className="text-sm text-slate-500 mt-1 leading-relaxed">
            Search by brand name or website. We&apos;ll automatically fetch the brand name, logo and website for you.
          </DialogDescription>
        </div>
      </div>

      <button
        type="button"
        onClick={onClose}
        className="absolute right-6 top-6 p-1 rounded-lg text-slate-400 hover:text-slate-600 transition-colors focus:outline-none"
        aria-label="Close"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
};
